module.exports = __webpack_public_path__ + "img/face-smile-wink.1133f15b.svg";